import { Navigate, useParams } from 'react-router';

import { useExplorePathPrefix } from '@/context/DbtCloudProvider';
import { useAdminEnvironment } from '@/hooks/admin/environments';
import { useTargetEnvironmentType } from '@/hooks/useTargetEnvironmentType';

export const ProjectRedirect = () => {
  const params = useParams();
  const url = `environments/production/${params['*']}`;
  return <Navigate replace to={url} />;
};

export const EnvironmentRedirect = () => {
  const params = useParams();
  const explorePrefix = useExplorePathPrefix();
  const accountId = (params.accountId && parseInt(params.accountId)) || 0;
  const envId = (params.environmentId && parseInt(params.environmentId)) || 0;
  const getTargetEnvironmentType = useTargetEnvironmentType();
  const environment = useAdminEnvironment(envId, accountId);
  const projectId = environment.data?.project_id;
  const environmentType = getTargetEnvironmentType(envId);
  if (!environmentType || !projectId || !accountId) {
    return null;
  }
  const url = `${explorePrefix}/${params.accountId}/projects/${projectId}/environments/${environmentType}/${params['*']}`;
  return <Navigate replace to={url} />;
};
